import { render } from "./MarketingInput.vue?vue&type=template&id=054a3f92&scoped=true"
import script from "./MarketingInput.vue?vue&type=script&lang=js"
export * from "./MarketingInput.vue?vue&type=script&lang=js"

import "./MarketingInput.vue?vue&type=style&index=0&id=054a3f92&lang=scss&scoped=true"

import exportComponent from "/Users/ferlando/Desktop/Baboon/baboon-pos/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-054a3f92"]])

export default __exports__